export default function extractProjectName(projects) {
  const projectName = projects.map(project => {
    return project.name.replace(/^\d*_/g, '')
  })
  return projectName
}
